import type { ReactNode, Ref } from "react";

export function CampaignDraftShell({
  header,
  stepper,
  children,
  scrollRef,
}: {
  header: ReactNode;
  stepper: ReactNode;
  children: ReactNode;
  scrollRef?: Ref<HTMLDivElement>;
}): React.JSX.Element {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col overflow-x-hidden" data-testid="campaign-draft-shell">
      <header className="min-w-0 shrink-0 overflow-x-hidden border-b border-line/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.98)_0%,rgba(248,250,252,0.94)_100%)] px-4 py-2.5">
        <div className="grid min-w-0 gap-2">
          {header}
          {stepper}
        </div>
      </header>
      <div
        ref={scrollRef}
        className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden"
        data-testid="campaign-draft-scroll"
      >
        <div className="flex min-w-0 flex-col gap-4 p-4 sm:p-5" data-testid="campaign-draft-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export function CampaignPostLaunchShell({
  header,
  children,
}: {
  header: ReactNode;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col overflow-x-hidden" data-testid="campaign-post-launch-shell">
      <header className="min-w-0 shrink-0 overflow-x-hidden border-b border-line/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.98)_0%,rgba(248,250,252,0.94)_100%)] px-4 py-2.5">
        {header}
      </header>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden p-4 sm:p-5" data-testid="campaign-post-launch-content">
          {children}
        </div>
      </div>
    </div>
  );
}
